import Schema from "@components/Schema";
import SEOHEAD from "@components/SEOHEAD";
import Comments from "@components/ui/details/comments";
import Description from "@components/ui/details/Description";
import FAQ from "@components/ui/details/FAQ";
import Prerequisites from "@components/ui/details/Prerequisites";
import NewCourses from "@components/ui/landing/NewCourses";
import Cards from "@components/ui/packege-details/cards";
import Details from "@components/ui/packege-details/Details";
import Head from "@components/ui/packege-details/head";
import ShoppingBox from "@components/ui/packege-details/shoppingBox";
import Video from "@components/ui/packege-details/video";
import { PreferCourseCard, Title } from "components";
import gate from "gate";
import { GetServerSideProps } from "next";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { FC, useEffect, useRef } from "react";
import { dehydrate, QueryClient, useQuery } from "react-query";
import { extractNumericIdFromCatchAll, sortArrayByOrder } from "src/utils";

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const queryClient = new QueryClient();
  const id = extractNumericIdFromCatchAll(ctx?.params?.id);
  if (!id) {
    return { notFound: true };
  }
  let isError = false;

  try {
    await queryClient.fetchQuery([`package`, id], () => gate.packageDetail(id));
  } catch (error: any) {
    isError = true;
    const statusCode = error?.response?.status;
    const errCode = error?.code;
    const isNetworkError =
      !error?.response || ["EAI_AGAIN", "ENOTFOUND"].includes(errCode);

    ctx.res.statusCode = isNetworkError ? 503 : statusCode || 500;
    console.log("=======>", error);
    return {
      props: {
        dehydratedState: dehydrate(queryClient),
        isError,
      },
    };
  }
  return {
    props: {
      dehydratedState: dehydrate(queryClient),
      isError,
    },
  };
};
type Props = {
  isError: boolean;
};

// export const getServerSideProps: GetServerSideProps = async (ctx: any) => {
//     let data;
//     try {
//         const res: any = await gate.packageDetail(ctx?.query?.id[0]);
//         data = res;
//     } catch (error) {
//         console.log(error);
//         return {
//             notFound: true,
//         };
//     }
//     return {
//         props: {
//             data: data?.data?.packageDetail,
//             id: ctx?.query?.id[0],
//         },
//     };
// };
// type Props = {
//     id: number | string | undefined;
//     data: any;
// };

function picRandomColor(index: number) {
  const colors = ["#0577AF", "#4F9B0A", "#E65800", "#77278B"];
  return colors[index % colors.length];
}

const Index: FC<Props> = ({ isError }) => {
  const { query }: any = useRouter();
  const id = extractNumericIdFromCatchAll(query?.id);
  const { data } = useQuery([`package`, id], () => gate.packageDetail(id), {
    select: (data: any) => data?.data?.packageDetail,
    enabled: !!id,
    refetchOnWindowFocus: false,
    onError: (error) => console.log(error),
  });

  useEffect(() => {
    console.log("[package-details] raw query.id:", query?.id, "extracted id:", id);
  }, [query?.id, id]);
  const refElement: React.LegacyRef<HTMLSpanElement> | any = useRef();
  useEffect(() => {
    if (query.campaign_id && query.phone_number) {
      localStorage.setItem(
        "campaign",
        JSON.stringify({
          campaign_id: query?.campaign_id,
          followup_id: query?.followup_id,
          phone_number: query?.phone_number,
          url: window.location.origin + window.location.pathname,
          isPromotion: query?.isPromotion,
        })
      );
    }
  }, []);
  return (
    <>
      <SEOHEAD
        {...{
          canonical: `package-details/${id}/${data?.seoUrlDescription}`,
          keyword: data?.seoKeyword,
          seoDescription: data?.seoDescription,
          title: data?.title ?? "بسته های دادبانان",
          image: data?.image,
        }}
      />
      <Schema
        {...{
          title: data?.title ?? "بسته های دادبانان",
          keyword: data?.seoKeyword,
          seoDescription: data?.seoDescription,
          description: data?.shortDescription,
          featuredImage: data?.image,
          date: data?.createdDate ?? data?.startDate,
          price: data?.price,
          commentCount: data?.comments?.length,
          ratingCount: 5,
          canonical: `package-details/${id}/${data?.seoUrlDescription}`,
        }}
      />
      <div className="bg-[#FAFAFC] pb-10">
        <Head
          {...{
            summaryVideo: data?.summaryVideo,
            summaryVideoName: data?.summaryVideoName,
            title: data?.title,
            description: data?.shortDescription,
            percent: {
              offlinePercentage: data?.offlinePercentage,
              onlinePercentage: data?.onlinePercentage,
              inclassPercentage: data?.inclassPercentage,
            },
          }}
        />
        <Cards
          {...{
            startDate: data?.startDate,
            endDate: data?.endDate,
            hasCertificate: data?.hasCertificate,
            numerofSessions: data?.numerofSessions,
            duration: data?.duration,
            releaseDate: data?.releaseDatetime,
          }}
        />
        <div className="mt-4 flex flex-col-reverse gap-x-[20px] px-[10%] md:mt-10 lg:mt-16 lg:px-[13%] xl:flex-row">
          <div className="w-full md:mt-10 xl:mt-0 xl:w-[66%]">
            <Description
              title={data?.title}
              fullDescription={data?.fullDescription}
            />
          </div>
          <ShoppingBox
            {...{
              id: data?.id,
              isBuyable: data?.isBuyable,
              badge: data?.badge,
              price: data?.price,
              dicount: data?.dicount,
              refPrerequisites: refElement,
              installmentPayments: data?.installmentPayments,
              allowSnapPay: data?.allowSnapPay,
              snappPayInstallment: data?.snappPayInstallment,
            }}
          />
        </div>
        {data?.extraDescription &&
          data?.extraDescription !== '<p class="ql-align-center"><br></p>' && (
            <Details
              {...{ image: data?.image, description: data?.extraDescription }}
            />
          )}{" "}
        <div className="mt-4 px-[10%] md:mt-10 lg:mt-16 lg:px-[13%]">
          <Title title="محتوای دوره" wrapperClass="mb-5" />
          <div className="grid grid-cols-1 gap-y-4 gap-x-5 md:grid-cols-2 md:gap-y-12 xl:grid-cols-4">
            {data?.courses?.map(
              (
                {
                  color,
                  image,
                  id,
                  title,
                  discount,
                  percent,
                  price,
                  priceWidoutDiscount,
                  courseType,
                  date,
                  teacherNames,
                  seoUrlDescription,
                  isBuyable,
                }: any,
                index: number
              ) => (
                <Link key={JSON.stringify(id)} href={`/course/${id}`}>
                  <PreferCourseCard
                    {...{
                      type: "packege-details",
                      color: picRandomColor(index),
                      image,
                      id,
                      discount,
                      isBuyable,
                      teacherNames,
                      title,
                      percent,
                      price,
                      priceWidoutDiscount,
                      courseType,
                      date,
                      seoUrlDescription,
                    }}
                  />
                </Link>
              )
            )}
          </div>
        </div>
        {data?.video && (
          <div className="mt-4 flex w-full gap-x-2 md:mt-10 md:px-[10%] lg:mt-16 lg:px-[13%]">
            <Video
              {...{
                url: data?.video,
                name: data?.title,
                date: data?.startDate ?? data?.createdDate,
                description: data?.shortDescription,
                isSchema: !!data?.video,
                canonical: `package-details/${id}/${data?.seoUrlDescription}`,
              }}
            />
          </div>
        )}
        <span ref={refElement} />
        {data?.coursePrerequisites?.length !== 0 && (
          <div className="mt-4 flex w-full gap-x-2 px-[10%] md:mt-10 lg:mt-16 lg:px-[13%]">
            <Prerequisites data={data?.coursePrerequisites} />
          </div>
        )}
        {data?.frequentlyAskedQuestions?.length !== 0 && (
          <div className="mt-4 flex w-full gap-x-2 px-[10%] md:mt-10 lg:mt-16 lg:px-[13%]">
            <FAQ
              frequentlyAskedQuestions={
                sortArrayByOrder(data?.frequentlyAskedQuestions, "order") as any
              }
            />
          </div>
        )}{" "}
        <div className="mt-4 flex w-full gap-x-2 px-[10%] md:mt-10 lg:mt-16 lg:px-[13%]">
          <Comments id={id} comments={data?.comments} type="package" />
        </div>
        {data?.recommendedCourses?.length !== 0 && (
          <div className="mt-4 flex w-full gap-x-2 px-[10%] md:mt-10 lg:mt-16 lg:px-[13%]">
            <NewCourses
              title="دوره ها و بسته های پیشنهادی"
              data={data?.recommendedCourses}
              breakpoints={{
                300: {
                  slidesPerView: 1,
                  spaceBetween: 5,
                },
                375: {
                  slidesPerView: 1.1,
                  spaceBetween: 5,
                },
                767: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 4,
                  spaceBetween: 24,
                },
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default Index;
